import React from 'react';
import i_ from 'i18next';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import { withTheme } from '@material-ui/core/styles';

class EvolucaoDialog extends React.Component {
  state = { opened: false, columns: [], data: { columns: [] } };

  static propTypes = {
    onOK: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    columnFunc: PropTypes.func,
    columns: PropTypes.array,
    opened: PropTypes.bool,
    data: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.styles = {
      titleStyle: {
        background: this.props.theme.palette.primary.main,
        color: this.props.theme.palette.primary.contrastText,
      },
      bodyStyle: {
        padding: 0,
        overflowY: 'auto',
        height: '450px',
        maxHeight: '450px',
      },
      contentStyle: {
        width: '80%',
        maxWidth: '1000px',
      },
      actionLeft: {
        marginRight: 'auto',
      },
      inputStyle: {
        display: 'none',
        width: '100%',
      },
    };
  }

  componentWillReceiveProps(props) {
    let { opened, columns, data } = props;
    this.setState({ opened });
    if (columns) {
      this.setState({ columns });
    }
    if (data) {
      this.setState({ data });
    }
  }

  actions = onOK => {
    let actions = [];
    actions.push(
      <Button color="primary" key="ok" onClick={e => onOK(e)}>
        {i_.t('dialogs.close')}
      </Button>
    );
    return actions;
  };

  render() {
    const { onOK, title, columnFunc } = this.props;
    const { columns, opened, data } = this.state;
    let cols =
      columns && columns.length > 0 ? columns : data ? data.columns : [];
    if (columnFunc) {
      cols.forEach(c => (c[0] = columnFunc(c[0])));
    }
    let timeData = {
      x: 'x',
      columns: cols,
    };
    if (data.colors) {
      if (columnFunc) {
        Object.keys(data.colors).forEach(
          k => (data.colors[columnFunc(k)] = data.colors[k])
        );
      }
      timeData.colors = data.colors;
    }
    let axis = {
      x: {
        type: 'timeseries',
        tick: {
          format: '%d/%m/%Y',
        },
      },
    };
    return (
      <Dialog maxWidth="md" fullWidth={true} open={opened}>
        <DialogTitle style={this.styles.titleStyle} disableTypography={true}>
          <Typography style={this.styles.titleStyle} variant="title">
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <C3Chart
            style={{ height: '450px', maxHeight: '450px' }}
            data={timeData}
            axis={axis}
            padding={{ right: 25 }}
          />
        </DialogContent>
        <DialogActions style={this.styles.actionsContainerStyle}>
          {this.actions(onOK)}
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTheme()(EvolucaoDialog);



// WEBPACK FOOTER //
// ./src/components/commons/EvolucaoDialog.js